import _ from 'lodash';
import { useState, useMemo, useEffect, useCallback } from 'react';
import { useRsi } from './useRsi.js';
import { useStepState } from './useStepState.js';

function usePersistentState(stateVarName, value, dependencies) {
    const { stepState, setStepState } = useStepState();
    const { persistStateOnNavigation } = useRsi();
    const [currentValue, setCurrentValue] = useState(persistStateOnNavigation ? stepState[stateVarName]?.value ?? value : value);
    const deps = useMemo(() => (dependencies ? dependencies : []), [dependencies]);
    //When dependencies change, reset the value to the consumers default value
    useEffect(() => {
        if (persistStateOnNavigation && _.isEqual(deps, stepState[stateVarName]?.deps) === false) {
            setState(value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...deps]);
    const setState = useCallback((value) => {
        setCurrentValue(value);
        setStepState((prev) => ({
            ...prev,
            [stateVarName]: { value, deps },
        }));
    }, [deps, stateVarName, setStepState]);
    return [currentValue, persistStateOnNavigation ? setState : setCurrentValue];
}

export { usePersistentState };
